import { getMonthString, getDay } from '@utils/dates';
import { getDateKey } from '../date-time-helper';
import { plannerItemTypes } from '../../planner-constants';

export const getDateTitle = (date) => {
  const targetDate = new Date(date);
  return `${getDay(targetDate)} ${getMonthString(targetDate, 'long')}`;
};

export const getDayTitle = (date) => {
  const dateKey = getDateKey(date);
  const plannerItemType = plannerItemTypes.DAY_TITLE;
  return {
    plannerItemType,
    dateKey,
    title: getDateTitle(date),
    date
  };
};

export const getGreetingItem = () => ({
  plannerItemType: plannerItemTypes.GREETING
});

export const getSubscriptionFeedbackItem = () => ({
  plannerItemType: plannerItemTypes.SUBSCRIPTION_FEEDBACK
});

export const getSubscriptionFeedbackItemV2 = (itemInfo) => ({
  plannerItemType: plannerItemTypes.SUBSCRIPTION_FEEDBACK_V2,
  itemInfo
});

export const getSubscriptionRenewalItem = (itemInfo) => ({
  plannerItemType: plannerItemTypes.SUBSCRIPTION_RENEWAL,
  itemInfo
});

export const getFeatureIntroductionItem = (itemInfo) => ({
  plannerItemType: plannerItemTypes.FEATURE_INTRODUCTION,
  itemInfo
});

export const getFeatureAwarenessItem = (itemInfo) => ({
  plannerItemType: plannerItemTypes.FEATURE_AWARENESS,
  itemInfo
});

export const getBrowseItem = () => ({
  plannerItemType: plannerItemTypes.BROWSE
});

export const getEventItem = (event) => ({
  ...event,
  plannerItemType: plannerItemTypes.EVENT,
  dateKey: getDateKey(event.activityAt)
});

export const getFreeTrialItem = (itemInfo) => ({
  plannerItemType: plannerItemTypes.FREE_TRIAL_CARD,
  itemInfo
});
